import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';

@Injectable({
  providedIn: 'root'
})
export class DocumentEmailService {
  constructor(private http: ApiClient) {}

  email(payload: {
    type: 'hire' | 'sale' | 'booking';
    documentId: number;
    email: string;
  }) {
    return this.http.post(`email-document`, payload);
  }

  getEmails(resource: string, resourceId: number) {
    return this.http.get<EmailDetails[]>(`emails/${resource}/${resourceId}`);
  }
}

export interface EmailDetails {
  id: number;
  subject: string;
  user_id: number;
  to: string;
  notes: string;
  opened_at: string[];
  delivered_at: string;
  failed_at: string;
  emailable_type: 'docket' | 'saleDocket' | 'booking';
  emailable_id: number;
  link: string;
  created_at: string;
}